class Anchor {
  constructor(element) {
    this.element = element;

    this.findElements();
    this.init();
    this.attachEvents();
  }

  findElements() {
    const { targetId } = this.element.dataset;

    this.target = document.querySelector(targetId);

    if (!this.target) {
      throw new Error(`NavigationTypeSection: target section with <id> ${this.target} is undefined`);
    }
  }

  init() {
    this.targetOffsetYPosition = this.target.getBoundingClientRect().top + window.scrollY;
  }

  attachEvents() {
    this.element.addEventListener('click', this.clickHandler.bind(this));
  }

  clickHandler(event) {
    event.preventDefault();

    window.scrollTo({
      top: this.targetOffsetYPosition,
      behavior: 'smooth',
    });
  }
}

export default Anchor;
